export interface PopulateDataLayerBaseProps {
  sysEnv: string;
}

export function populateDataLayerBase({ sysEnv }: PopulateDataLayerBaseProps) {
  window.dumbleData = window.dumbleData ?? {
    site: { name: 'Scholastic Education Platform' },
    page: {
      language: document.documentElement.lang,
      bundleType: null,
      bundleFocus: null,
    },
    user: {
      authenticationType: 'Ednition',
      hasClass: false,
      grade: null,
      parentOrgId: null,
    },
  };

  window.dumbleData.site.sysEnv = sysEnv;
}

export interface PopulateDataLayerUserProps {
  currentRole: string;
  grade?: string;
  hasClass: boolean;
  orgId: string;
  parentOrgId?: string | null;
  userId: string;
}

export function populateDataLayerUser({
  currentRole,
  grade,
  hasClass,
  orgId,
  parentOrgId,
  userId,
}: PopulateDataLayerUserProps) {
  window.dumbleData.user.orgId = orgId;
  window.dumbleData.user.parentOrgId = parentOrgId;

  window.dumbleData.user.platformUserId = userId;
  window.dumbleData.user.userRole = currentRole;
  if (currentRole === 'student') {
    window.dumbleData.user.grade = grade;
  } else if (hasClass) {
    window.dumbleData.user.grade = null;
    window.dumbleData.user.hasClass = hasClass;
  }
}

export interface PopulateDataLayerPageProps {
  bundleFocus: string | null;
  bundleType: string | null;
  destinationUrl: string;
  pageName: string | null;
  pageType: string | null;
  productCodes: string[] | null;
  siteSection: string | null;
}

export function populateDataLayerPage({
  bundleFocus,
  bundleType,
  destinationUrl,
  pageName,
  pageType,
  productCodes,
  siteSection,
}: PopulateDataLayerPageProps) {
  window.dumbleData.page.bundleFocus = bundleFocus;
  window.dumbleData.page.bundleType = bundleType;
  window.dumbleData.page.destinationUrl = destinationUrl;
  window.dumbleData.page.domain = window.location.origin;
  window.dumbleData.page.pageName = pageName;
  window.dumbleData.page.pageType = pageType;
  window.dumbleData.page.productCodes = productCodes;
  window.dumbleData.page.siteSection = siteSection;
}
